module.exports = __webpack_public_path__ + "static/media/custom-filtering-inactive.1c347238.svg";